import { useEffect } from 'react';

import { useHistory } from 'react-router-dom';

declare global {
  interface Window {
    ga?: (key: string, ...args: string[]) => void;
  }
}

export const useTracking = (trackingId: string) => {
  const { listen } = useHistory();

  useEffect(() => {
    const unlisten = listen((location) => {
      setTimeout(() => {
        if (window.ga) {
          // Wait until the title is changed.
          window.ga('create', trackingId, 'auto');
          window.ga('send', 'pageview', location.pathname);
        }
      }, 1000);
    });

    return unlisten;
  }, [trackingId, listen]);
};
